import FaqSection from './faq-section';

export default FaqSection;
export {FaqSection};